// extracted by mini-css-extract-plugin
module.exports = {"fixedSingleRouteRow":"ProductsList_fixedSingleRouteRow__1OOUp"};